.bar {
  display: flex;
  align-items: center;
  gap: var(--sp-5);
  padding: var(--sp-3) var(--sp-6);
  border-bottom: var(--bw) solid var(--warn-border);
  background: var(--warn-bg);
  color: var(--warn);
  box-shadow: var(--glow-warn);
  font-size: var(--fs-sm);
}

.text {
  flex: 1;
  min-width: 0;
}

.action,
.close {
  border: 0;
  background: none;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.close {
  text-decoration: none;
  font-size: var(--fs-md);
  line-height: 1;
}

.action:disabled {
  opacity: 0.6;
  cursor: default;
}
